import React from 'react';
import { loadModules } from "esri-loader";
import { withNamespaces } from "react-i18next";
import i18n from "i18next";
import { convertHex2Array, serialize } from "../../../../utils";
import { setServiceIntensityLayerRenderer, sortLayers } from "../../../../libs/arcgis/layers/utils";

const objectsPopupTemplate = {
    title: i18n.t('common:fields.object'),
    content: [
        {
            type: "fields",
            fieldInfos: [
                {
                    fieldName: 'type',
                    label: i18n.t('common:fields.type')
                },
                {
                    fieldName: 'name',
                    label: i18n.t('common:fields.name')
                },
                {
                    fieldName: 'year',
                    label: i18n.t('common:fields.buildingYear')
                },
                {
                    fieldName: 'cityPart',
                    label: i18n.t('common:fields.cityPart')
                },
                {
                    fieldName: 'publicComment',
                    label: i18n.t('common:fields.publicComment')
                }
            ]
        }, {
            type: "text",
            text: "<div class='text-center'><img class='d-inline-block mb-2' src='" + process.env.REACT_APP_API_V2 + "map/public/object/{id}/image' alt=''/></div><div class='text-center'><a href='" + window.location.origin + "/objects/{id}' target=\"_blank\">" + i18n.t('common:map.url') + "</a></div>"
        }
    ],
};

const problemsPopupTemplate = {
    title: i18n.t('common:header.problem'),
    content: [
        {
            type: "fields",
            fieldInfos: [
                {
                    fieldName: 'id',
                    label: i18n.t('common:fields.problemId')
                },
                {
                    fieldName: 'type',
                    label: i18n.t('common:fields.type')
                },
                {
                    fieldName: 'status',
                    label: i18n.t('common:fields.status')
                },
                {
                    fieldName: 'createdAt',
                    label: i18n.t('common:fields.createdAt')
                }
            ]
        }, {
            type: "text",
            text: "<div class='text-center'><img class='d-inline-block mb-2' src='" + process.env.REACT_APP_API_V2 + "map/public/problem/{id}/image' alt=''/></div><div class='text-center'><a href='" + window.location.origin + "/problems/{id}' target=\"_blank\">" + i18n.t('common:map.url') + "</a></div>"
        }
    ],
};

class MapLayerGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            layerGroups: [],
        };
    }

    render() {
        return null;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { t } = this.props;

        loadModules([
            'esri/layers/GroupLayer',
            'esri/layers/GeoJSONLayer',
            "esri/config",
        ]).then(([GroupLayer, GeoJSONLayer, esriConfig]) => {
            esriConfig.request.timeout = 2400000;
            const groups = this.props.groups || [];
            groups.forEach(group => {
                let groupLayer = nextProps.map.allLayers.find(layer => layer.id === group.name),
                    layers = group.subLayers || [],
                    groupLayers = [],
                    template = (group.name === 'objects') ? objectsPopupTemplate : problemsPopupTemplate,
                    renderer = null;
                sortLayers(layers);

                //Remove completely filtered layers
                if (groupLayer && groupLayer.id === group.id && layers.length > 0) {
                    let layersForRemove = [];
                    for (let existedLayer of groupLayer.layers.items) {
                        let removeLayer = true;
                        for (let newLayer of group.subLayers) {
                            if (String(newLayer.id) === existedLayer.id) {
                                removeLayer = false;
                                break;
                            }
                        }
                        if (removeLayer) {
                            layersForRemove.push(existedLayer);
                        }
                    }
                    groupLayer.removeMany(layersForRemove);
                }

                if (group.name === 'problems' && group.colors) {
                    let symbol = {
                        type: "simple-marker",
                        outline: { color: 'white', width: 0.5 }
                    };
                    renderer = {
                        type: "class-breaks", // autocasts as new ClassBreaksRenderer()
                        field: "stateId",
                        classBreakInfos: [],
                    };

                    group.colors.forEach(color => {
                        symbol.color = color.color;
                        renderer.classBreakInfos.push({
                            minValue: color.value,
                            maxValue: color.value,
                            symbol: Object.assign({}, symbol),
                        });
                    });
                } else if (group.name === 'objects') {
                    const treeLayers = group.subLayers.filter((subLayer) => subLayer.title === 'Puud');
                    if (Array.isArray(treeLayers) && treeLayers.length === 1) {
                        let treeLayer = treeLayers[0];
                        treeLayer.colors = JSON.parse(treeLayer.color);
                        let symbol = {
                            type: "picture-marker",
                            width: '42pt',
                            height: '42pt',
                        };
                        renderer = {
                            type: "class-breaks", // autocasts as new ClassBreaksRenderer()
                            field: "treeType",
                            classBreakInfos: [],
                        };
                        Object.keys(treeLayer.colors).map((treeType, index) => {
                            symbol.color = treeLayer.colors[treeType];
                            symbol.url = process.env.REACT_APP_API_V2 + "object_type/" + treeLayer.id + "/icon.svg?treeType=" + treeType;
                            let treeTypeCode = 0;
                            if (treeType === 'leaf') {
                                treeTypeCode = 1;
                            } else if (treeType === 'conifer') {
                                treeTypeCode = 2;
                            } else if (treeType === 'fruit') {
                                treeTypeCode = 3;
                            }

                            renderer.classBreakInfos.push({
                                minValue: treeTypeCode,
                                maxValue: treeTypeCode,
                                symbol: Object.assign({}, symbol),
                            });

                            return true;
                        });
                        treeLayer.renderer = renderer;
                    }
                }

                layers.forEach(layer => {
                    if (!groupLayer || !groupLayer.findLayerById(layer.id)) {
                        let url = layer.url ? layer.url : process.env.REACT_APP_API_V2 + 'map/public/layers/' + group.name + '/' + layer.id + '.geojson';
                        if (!layer.urlParams) {
                            layer.urlParams = {};
                        }
                        url += "?";
                        if (group.filter) {
                            url += '&' + serialize(group.filter);
                        }
                        if (localStorage.getItem('user_token')) {
                            layer.urlParams.bearer = localStorage.getItem('user_token');
                        }

                        if (layer.urlParams !== {}) {
                            url += '&' + serialize(layer.urlParams);
                        }
                        let newLayer = new GeoJSONLayer({
                            url,
                            title: layer.title ? layer.title : '',
                            id: layer.id,
                            visible: layer.visible,
                            visibilityMode: 'inherited',
                            popupEnabled: true,
                            legendEnabled: true,
                            objectIdField: 'id',
                            popupTemplate: layer.popupTemplate ? layer.popupTemplate : template,
                            //index: layer.index + 1000,
                            index: layer.title.indexOf("määratud") > -1 ? layer.index + 1000 : layer.index,
                            outFields: ["*"]
                        });

                        if (group.name === 'objects') {
                            let type = String(layer.type).toLowerCase();
                            if (type === 'point') {
                                if (layer.title === 'Puud') {
                                    renderer = layer.renderer;
                                } else if (layer.icon) {
                                    let symbol = {
                                        type: "picture-marker",
                                        width: '15pt',
                                        height: '15pt',
                                        url: process.env.REACT_APP_API_V2 + "object_type/" + layer.id + "/icon.svg?rand=" + new Date().getTime(),
                                    };
                                    renderer = {
                                        type: "simple",  // autocasts as new SimpleRenderer()
                                        symbol,
                                        classBreakInfos: []
                                    };

                                    if (layer.colors) {
                                        renderer.type = "class-breaks";
                                        renderer.field = "maintenanceStateId";
                                        renderer.classBreakInfos = [];
                                        layer.colors.forEach(color => {
                                            symbol.url = process.env.REACT_APP_API_V2 + "object_type/" + layer.id + "/icon.svg?color=" + encodeURIComponent(color.color);
                                            renderer.classBreakInfos.push({
                                                minValue: color.id,
                                                maxValue: color.id,
                                                symbol: Object.assign({}, symbol),
                                            });
                                        });
                                    }
                                } else {
                                    renderer = {
                                        type: "simple",  // autocasts as new SimpleRenderer()
                                        symbol: {
                                            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
                                            size: '14.1732pt',
                                            color: layer.color ? convertHex2Array(layer.color, 0.7) : [255, 128, 0, 0.7],
                                            outline: { color: 'grey', width: 0.5 }
                                        }
                                    };
                                    if (layer.colors) {
                                        renderer.type = "class-breaks";
                                        renderer.field = "maintenanceStateId";
                                        renderer.classBreakInfos = [];
                                        layer.colors.forEach(color => {
                                            renderer.symbol.color = color.color;
                                            renderer.classBreakInfos.push({
                                                minValue: color.id,
                                                maxValue: color.id,
                                                symbol: Object.assign({}, renderer.symbol),
                                            });
                                        });
                                    }
                                }
                            } else if (type === 'line'){
                                renderer = {
                                    type: "simple",  // autocasts as new SimpleRenderer()
                                    symbol: {
                                        cap:'butt',
                                        type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
                                        style: "solid",
                                        color: layer.color ? convertHex2Array(layer.color, 0.7) : [255, 128, 0, 0.7],
                                        outline: {  // autocasts as new SimpleLineSymbol()
                                            color: layer.color ? convertHex2Array(layer.color, 0.7) : [255, 128, 0, 0.7],
                                            width: "6px"
                                        }
                                    },
                                };

                                //If option color enabled. Except assigned sublayer (triangled)
                                if (layer.colors) {
                                    renderer.type = "class-breaks";
                                    renderer.field = "maintenanceStateId";
                                    renderer.classBreakInfos = [];
                                    layer.colors.forEach(color => {
                                        renderer.symbol.color = color.color;
                                        renderer.symbol.outline = {  // autocasts as new SimpleLineSymbol()
                                            color: color.color ? convertHex2Array(color.color, 0.7) : [255, 128, 0, 0.7],
                                            width: "6px"
                                        }
                                        renderer.classBreakInfos.push({
                                            minValue: color.id,
                                            maxValue: color.id,
                                            symbol: Object.assign({}, renderer.symbol),
                                        });
                                    });
                                } else if (layer.useServiceIntensityColors) {
                                    setServiceIntensityLayerRenderer(layer);
                                    renderer = layer.renderer;
                                }

                            } else {
                                renderer = {
                                    type: "simple",  // autocasts as new SimpleRenderer()
                                    symbol: {
                                        type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
                                        style: "solid",
                                        color: layer.color ? convertHex2Array(layer.color, 0.7) : [255, 128, 0, 0.7],
                                        outline: {  // autocasts as new SimpleLineSymbol()
                                            color: layer.color ? convertHex2Array(layer.color, 0.7) : [255, 128, 0, 0.7],
                                            width: "10px"
                                        }
                                    },
                                };

                                //If option color enabled. Except assigned sublayer (triangled)
                                if (layer.colors) {
                                    renderer.type = "class-breaks";
                                    renderer.field = "maintenanceStateId";
                                    renderer.classBreakInfos = [];
                                    layer.colors.forEach(color => {
                                        renderer.symbol.color = color.color;
                                        renderer.symbol.outline = {  // autocasts as new SimpleLineSymbol()
                                            color: color.color ? convertHex2Array(color.color, 0.7) : [255, 128, 0, 0.7],
                                            width: "10px"
                                        }
                                        renderer.classBreakInfos.push({
                                            minValue: color.id,
                                            maxValue: color.id,
                                            symbol: Object.assign({}, renderer.symbol),
                                        });
                                    });
                                } else if (layer.useServiceIntensityColors) {
                                    setServiceIntensityLayerRenderer(layer);
                                    renderer = layer.renderer;
                                }
                            }
                        }
                        if (renderer) {
                            newLayer.renderer = renderer;
                        }else if(layer.renderer){
                            newLayer.renderer = layer.renderer;
                        }

                        if (!groupLayer) {
                            // add new layer to new layer group
                            groupLayers.push(newLayer);
                        } else {
                            let existedLayer = groupLayer.findLayerById(String(layer.id));
                            if (!existedLayer) {
                                // add new layer to existing layer group
                                groupLayer.add(newLayer, newLayer.index);
                            } else if (existedLayer.url !== newLayer.url) {
                                groupLayer.remove(existedLayer);
                                groupLayer.add(newLayer, newLayer.index);
                            }
                        }
                    }
                });

                if (!groupLayer) {
                    let groupLayerProps = {
                        title: group.name ? t('sidebar.' + group.name) : 'Nimeta',
                        id: group.id || group.name || 'ignore_id',
                        visible: true,
                        layers: groupLayers,
                        opacity: this.props.opacity,
                        listMode: 'hide',
                    };

                    groupLayer = new GroupLayer(groupLayerProps);
                    this.setState(prevState => ({ layerGroups: [...prevState.layerGroups, groupLayers] }));
                    this.props.map.add(groupLayer);
                }
            });
        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.map.remove(this.state.layerGroups);
    }
}

export default withNamespaces('common')(MapLayerGroups);
